import { ArrowUpRight, TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/common/Reveal";

export const caseStudies = [
  {
    slug: "lumen-watches",
    name: "Lumen Watches",
    industry: "Premium Watches • UAE",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=900&q=80",
    metrics: [
      { v: "+412%", l: "Revenue" },
      { v: "6.8x", l: "ROAS" },
      { v: "+248%", l: "CVR" },
    ],
    note: "Full Shopify rebuild + paid scaling across Meta & Google.",
  },
  {
    slug: "aurora-audio",
    name: "Aurora Audio",
    industry: "Headphones • USA",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=900&q=80",
    metrics: [
      { v: "+$4.2M", l: "Added Revenue" },
      { v: "+186%", l: "ROAS" },
      { v: "1.8s", l: "LCP" },
    ],
    note: "Funnel rebuild, PDP optimization, creative refresh.",
  },
  {
    slug: "stride-soles",
    name: "Stride Soles",
    industry: "Sneakers • UK",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=900&q=80",
    metrics: [
      { v: "+289%", l: "AOV" },
      { v: "5.4x", l: "ROAS" },
      { v: "+312%", l: "CVR" },
    ],
    note: "CRO sprint + Meta creative engine.",
  },
];

export default function CaseStudies() {
  return (
    <section data-testid="case-studies-section" className="relative py-24 md:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">Case Studies</span>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
              Real brands. <span className="text-gradient">Real numbers.</span>
            </h2>
          </div>
          <Link
            to="/case-studies"
            data-testid="view-all-case-studies-link"
            className="inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-white transition group"
          >
            View all case studies
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {caseStudies.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.08}>
              <article
                data-testid={`case-study-card-${c.slug}`}
                className="group h-full overflow-hidden rounded-3xl bg-[#0A0A0C] border border-white/5 hover:border-blue-500/30 transition-all"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-1 text-xs glass-heavy px-3 py-1 rounded-full text-emerald-300">
                    <TrendingUp className="h-3 w-3" /> Scaling
                  </div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="text-xs text-zinc-400 uppercase tracking-wider">{c.industry}</div>
                    <h3 className="font-display text-2xl font-extrabold text-white">{c.name}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-3 gap-3">
                    {c.metrics.map((m) => (
                      <div key={m.l}>
                        <div className="font-display text-xl font-extrabold text-white">{m.v}</div>
                        <div className="text-[10px] text-zinc-500 uppercase tracking-wider mt-0.5">{m.l}</div>
                      </div>
                    ))}
                  </div>
                  <p className="mt-5 text-sm text-zinc-400 leading-relaxed">{c.note}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
